import { render, staticRenderFns } from "./AppointmentPlus.vue?vue&type=template&id=44a249aa"
import script from "./AppointmentPlus.vue?vue&type=script&lang=js"
export * from "./AppointmentPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports